// Propósito: manejar el identificador anónimo persistido en localStorage.

const ANON_SESSION_KEY = 'chatbotAnonymousId';

export const isValidAnonymousId = (value: string): boolean => /^anon_[0-9a-f]{32}$/i.test(value);

export const generateAnonymousId = (): string => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const hex = Array.from(bytes)
    .map(value => value.toString(16).padStart(2, '0'))
    .join('');
  return `anon_${hex}`;
};

export const getOrCreateAnonymousId = (): string => {
  const stored = localStorage.getItem(ANON_SESSION_KEY);
  if (stored && isValidAnonymousId(stored)) {
    return stored;
  }
  const fresh = generateAnonymousId();
  localStorage.setItem(ANON_SESSION_KEY, fresh);
  return fresh;
};

export const clearAnonymousId = (): void => {
  localStorage.removeItem(ANON_SESSION_KEY);
};
